import { FullLogo } from '@c/icons';
import BaseDrawer from '@c/drawers/BaseDrawer';
import Link from 'next/link';

interface MenuDrawer {
  show: boolean;
  dismiss: () => void;
}

const MenuDrawer = ({ show, dismiss }: MenuDrawer) => {
  return (
    <div className="min-w-[100vw]">
      <div className="top-[8rem]">
        <BaseDrawer
          show={show}
          dismiss={() => {
            dismiss();
          }}
        >
          <div className="h-full w-full px-5 py-10">
            <div className="flex items-center">
              <Link href="/" aria-label="Home">
                <FullLogo variant="default" width={200} height={60} />
              </Link>
            </div>
            <div className="flex flex-col gap-10 my-10">
              <Link
                href="#popular-right-now"
                className="text-[18px] font-medium hover:text-[#ED7523] transition-colors duration-300"
                onClick={dismiss}
              >
                Popular Items
              </Link>
              <Link
                href="#sell-today"
                className="text-[18px] font-medium hover:text-[#ED7523] transition-colors duration-300"
                onClick={dismiss}
              >
                Sell Today
              </Link>
              <Link
                href="#faqs"
                className="text-[18px] font-medium hover:text-[#ED7523] transition-colors duration-300"
                onClick={dismiss}
              >
                FAQs
              </Link>
            </div>

            <Link href="/sell">
              <button className="bg-[#ED7523] text-white py-2 px-6 rounded-[10px] font-semibold text-[16px] hover:bg-[#cf5c12] transition">
                Sell Your Gear
              </button>
            </Link>
          </div>
        </BaseDrawer>
      </div>
    </div>
  );
};

export default MenuDrawer;
